export default "__VITE_ASSET__BIVzZKSi__"